<template>
    <nav id="sidebar" v-if="showSidebar" :class="[isEscort ? 'margin-top-120':'']">
        <ul id="side-nav" aria-multiselectable="true" :class="{'bigger-top-margin':sexySantaBannerIsVisible}">

            <li class="tab">
                <a class="title" :href="regionRelativeUrl('/users/account/')">{{ translate.account.accountHome }}
                    <icon-component width="1.25em" :icon="fa_home()"></icon-component>
                </a>
            </li>

            <li class="tab">
                <a class="title" :href="regionRelativeUrl(NuxtRoutes.USERS.ACCOUNT_EDIT)">{{ translate.account.accountInfo }}
                    <icon-component :icon="fa_info_circle()"></icon-component>
                </a>
            </li>

            <li class="tab" v-if="isPunter || isEscort">
                <router-link class="title profile-views-item" :to="{name:'profile-views'}">
                    {{ translate.account.profileViews }}
                    <div class="notification-counter" v-if="userProfileViewsNotificationCount">
                        {{ userProfileViewsNotificationCount }}
                    </div>
                    <icon-component width="1.25em" :icon="fa_address_card()"></icon-component>
                </router-link>
            </li>

            <li class="tab" v-if="isEscort || isVenue">
                <a class="title" :href="regionRelativeUrl(NuxtRoutes.PRODUCTS.BUY_PREMIUM)">{{ translate.product.premium }}
                    <icon-component :icon="fa_stars()"></icon-component>
                </a>
            </li>

            <li class="tab" v-if="topLevelServiceProvider">
                <router-link class="title" :to="{name:'buy_credits'}">{{ translate.account.buyCreditsCardTitle }}
                    <icon-component width="1.25em" :icon="fa_credit_card_bold()"></icon-component>
                </router-link>
            </li>

            <li class="tab" v-if="isPunter || isEscort || isVenue">
                <a class="title messages-item"
                   :href="regionRelativeUrl('/users/account/messages')">
                    {{ translate.account.conversations.messages }}
                    <div class="notification-counter" v-if="conversationUnreadMessageCount">
                        {{ conversationUnreadMessageCount }}
                    </div>
                    <icon-component width="1.25em" :icon="fa_comments_alt()"></icon-component>
                </a>
            </li>

            <li class="tab" v-if="isPunter || isEscort || isVenue" :class="{'router-link-active': $route.name.startsWith('profile.')}">
                <a class="title collapsed"
                   role="button"
                   data-toggle="collapse"
                   data-parent="#side-nav"
                   href="#collapseOne"
                   aria-controls="collapseOne"
                   id="headingOne">
                    <span>{{ translate.account.manageProfile }}
                        <icon-component :icon="fa_chevron_down()"></icon-component>
                    </span>
                    <icon-component :icon="fa_user_circle()"></icon-component>
                </a>

                <ul id="collapseOne" class="collapse">
                    <span>
                        <li v-if="isPunter || isEscort || isVenue">
                            <router-link :to="{name: 'profile.photos'}">{{ translate.account.photosAndVideos }}
                                <icon-component :icon="fa_camera()"></icon-component>
                            </router-link>
                        </li>
                        <li v-if="isPunter || isEscort">
                            <router-link :to="{name: 'profile.about'}">{{ translate.account.aboutMe }}
                                <icon-component width="1.25em" :icon="fa_address_card()"></icon-component>
                            </router-link>
                        </li>
                        <li v-if="isEscort || isVenue">
                            <router-link :to="{name: 'profile.prices'}">{{ translate.account.prices }}
                                <icon-component :icon="fa_tags()"></icon-component>
                            </router-link>
                        </li>
                        <li v-if="isEscort || isVenue">
                            <router-link :to="{name: 'profile.working_hours'}">{{
                                    isVenue ? translate.account.venueWorkingHours : translate.account.workingHours
                                }}
                                <icon-component :icon="fa_clock()"></icon-component>
                            </router-link>
                        </li>
                        <li v-if="isPunter || isEscort || isVenue">
                            <router-link :to="{name: 'profile.faq'}"> {{ translate.account.cardFAQs }}
                                <icon-component :icon="fa_question_circle()"></icon-component>
                            </router-link>
                        </li>
                        <li v-if="isPunter || isEscort || isVenue">
                            <router-link :to="{name: 'profile.services'}">{{ translate.home.services }}
                                <icon-component width="1.25em" :icon="fa_lips()"></icon-component>
                            </router-link>
                        </li>
                    </span>
                </ul>
            </li>
            <li class="tab"><a class="title" :href="regionRelativeUrl('/users/logout/')" e2e-id="sidebar-logout">{{ translate.login.logout }}</a></li>

        </ul>
    </nav>

</template>

<script>
import userMixin from "@/components/mixins/userMixin";
import {
    fa_address_card,
    fa_camera, fa_chevron_down,
    fa_clock,
    fa_comments_alt, fa_credit_card_bold,
    fa_home,
    fa_info_circle,
    fa_lips,
    fa_question_circle,
    fa_stars,
    fa_tags, fa_user_circle
} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import {NuxtRoutes} from "@/core/constants/v2/nuxtRoutes";

function created() {
    /**
     * Adds class to reduce padding to sidebar when scrolled pass header on desktop
     */
    function reduceTopMarginLogic() {
        const windowWidth = $(window).width();
        const navigationEl = $("#sidebar");
        const reduceClassName = 'reduce-top-margin';

        const scrollPosition = $(document).scrollTop();
        const headerHeight = $("#header").outerHeight();
        const hasReduceClass = navigationEl.hasClass(reduceClassName);

        if (windowWidth > 768 && scrollPosition >= headerHeight) {
            if (!hasReduceClass) {
                navigationEl.addClass(reduceClassName);
            }
        } else {
            if (hasReduceClass) {
                navigationEl.removeClass(reduceClassName);
            }
        }
    }

    /**
     * Adds padding bottom to sidebar same as footer height so side nav cant 'go under' footer
     */
    function footerHeightPaddingToSidebar() {
        const windowWidth = $(window).width();

        if (windowWidth > 768) {
            const footerHeight = $("#content + footer").outerHeight();
            $('#sidebar').css('padding-bottom', footerHeight);
        } else {
            $('#sidebar').removeAttr('style');
        }
    }

    $(document).scroll(function () {
        reduceTopMarginLogic();
        footerHeightPaddingToSidebar();
    });
}

export default {
    components: {IconComponent},
    data() {
        return {
            NuxtRoutes,
        };
    },
    methods: {
        fa_chevron_down,
        fa_user_circle,
        fa_credit_card_bold,
        fa_comments_alt, fa_tags, fa_stars, fa_question_circle, fa_lips, fa_info_circle, fa_home, fa_clock, fa_camera, fa_address_card},
    created,
    mixins: [
        userMixin,
        regionsUrlMixin,
    ],
    computed: {
        ...mapState([
            'currentUser',
            'translate',
            'conversationUnreadMessageCount',
            'userProfileViewsNotificationCount',
            'sexySantaBannerIsVisible'
        ]),
        showSidebar() {
            return !_.get($store, 'getters.getIs404View', false) && !(_.get(this, '$route.name', '') == '404');
        }
    }
};
</script>
